import { ACTIVE_EDITION } from "@mk/active-edition";
export const gameEdition = ACTIVE_EDITION;
export const APP_EDITION = gameEdition.id;

export function formatDate(
  value: Date | number,
  options: Intl.DateTimeFormatOptions,
): string {
  return new Intl.DateTimeFormat(gameEdition.locale, options).format(value);
}

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  return new Intl.NumberFormat(gameEdition.locale, options).format(value);
}

export function formatPercent(value: number): string {
  return new Intl.NumberFormat(gameEdition.locale, {
    style: "percent",
    maximumFractionDigits: 0,
  }).format(value);
}

export function upperLabel(value: string): string {
  return value.toLocaleUpperCase(gameEdition.locale);
}
